/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkCreateTimeEntriesPayload } from '../models/BulkCreateTimeEntriesPayload';
import type { TimeEntryCreate } from '../models/TimeEntryCreate';
import type { TimeEntryRead } from '../models/TimeEntryRead';
import type { TimeEntryWithDetails } from '../models/TimeEntryWithDetails';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class MonitoringService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Create Time Entry
     * Create a new time entry.
     * @param clusterId
     * @param requestBody
     * @returns TimeEntryRead Successful Response
     * @throws ApiError
     */
    public createTimeEntry(
        clusterId: string,
        requestBody: TimeEntryCreate,
    ): CancelablePromise<TimeEntryRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/monitoring/create-time-entry',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Bulk Create Time Entries
     * @param clusterId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public bulkCreateTimeEntries(
        clusterId: string,
        requestBody: BulkCreateTimeEntriesPayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/monitoring/bulk-create-time-entries',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Time Entry
     * Delete a time entry.
     * @param timeEntryId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteTimeEntry(
        timeEntryId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/monitoring/delete-time-entry/{time_entry_id}',
            path: {
                'time_entry_id': timeEntryId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Time Entries For Activity
     * List time entries with optional filtering.
     * @param clusterId
     * @param activityId
     * @returns TimeEntryWithDetails Successful Response
     * @throws ApiError
     */
    public listTimeEntriesForActivity(
        clusterId: string,
        activityId: string,
    ): CancelablePromise<Array<TimeEntryWithDetails>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/monitoring/list-time-entries-for-activity',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'activity_id': activityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Total Time Spent For Activity
     * @param clusterId
     * @param activityId
     * @returns number Successful Response
     * @throws ApiError
     */
    public getTotalTimeSpentForActivity(
        clusterId: string,
        activityId: string,
    ): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/monitoring/get-total-time-spent-for-activity',
            path: {
                'cluster_id': clusterId,
            },
            query: {
                'activity_id': activityId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
